import type { IconDefinition } from '../index.tsx';

export const iconArrowLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowLeft',
  icon: [
    16,
    16,
    [],
    '',
    'M8 10L8 14L6 14L-2.62268e-07 8L6 2L8 2L8 6L16 6L16 10L8 10Z',
  ],
};
